var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterArrowBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10228_933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0562 17.5538L39.1692 4.75606C39.7013 4.23366 40 3.52699 40 2.7904C40 2.0538 39.7013 1.34714 39.1692 0.824736C38.9037 0.563405 38.5877 0.355982 38.2396 0.21443C37.8914 0.0728786 37.518 0 37.1409 0C36.7637 0 36.3903 0.0728786 36.0422 0.21443C35.694 0.355982 35.3781 0.563405 35.1125 0.824736L22.028 13.6503C21.7625 13.9117 21.4465 14.1191 21.0984 14.2606C20.7502 14.4022 20.3768 14.4751 19.9997 14.4751C19.6225 14.4751 19.2491 14.4022 18.901 14.2606C18.5529 14.1191 18.2369 13.9117 17.9713 13.6503L4.88685 0.824736C4.35268 0.299713 3.62669 0.00328981 2.86858 0.000675388C2.11047 -0.00193903 1.38234 0.289472 0.844387 0.810798C0.306427 1.33212 0.00269699 2.04066 1.90735e-05 2.78054C-0.00265884 3.52042 0.295933 4.23104 0.830105 4.75606L13.9431 17.5538C15.5501 19.1202 17.7285 20 19.9997 20C22.2709 20 24.4492 19.1202 26.0562 17.5538Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10228_933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterArrowBottom);
export default __webpack_public_path__ + "static/media/filter-arrow-bottom.3ab4398bac52982a400a9f8b431c41f8.svg";
export { ForwardRef as ReactComponent };